import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { PasswordResetPage } from 'src/app/model/page/group/user/password-reset-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {
  passwordResetPage: PasswordResetPage = {} as PasswordResetPage;
  resetPasswordForm: FormGroup = new FormGroup({
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
    email: new FormControl('test@gmail.com')
  });
  submitted = false;
  submitPassword = false;
  showPassword = false;
  showConfirmPassword = false;
  showCurrentPassword = false;
  constructor(private contentfulService: ContentfulService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'Reset Password' };
    this.contentfulService.getPageContentWithEntries(query).then((passwordResetPageEntries) => {
      this.mapBanner(passwordResetPageEntries);
    });
    this.resetPasswordForm = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20), Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/)]],
        email: [
          { value: 'test@gmail.com', disabled: true },
          [Validators.required, Validators.minLength(2), Validators.maxLength(20), Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/)]
        ]
      },

      {
        validator: this.ConfirmedValidator('password', 'confirmPassword')
      }
    );
  }
  private mapBanner(passwordResetPageEntries: Entry<any>[]) {
    passwordResetPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.passwordResetPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  changePasswordSubmit() {
    this.submitPassword = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }
  }
  public togglePassword() {
    this.showPassword = !this.showPassword;
  }
  public toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  public toggleCurrentPassword() {
    this.showCurrentPassword = !this.showCurrentPassword;
  }
  get f(): { [key: string]: AbstractControl } {
    return this.resetPasswordForm.controls;
  }
  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  OnPasswordRestFormSubmit() {
    this.submitPassword = true;
    if (this.resetPasswordForm.invalid) {
      return;
    }
  }
}
